import React, { useEffect, useState } from 'react';
import { Row, Col, message, Button } from 'antd';
import DndListCard from 'Molecules/DndListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAds } from '../ducks/actions'
import { removeAd, bulkRemoveAds, updateAdOrder } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { useTranslate } from 'Translate';

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ads = useSelector((state) => state.loyaltyApp.ads);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const i18n = useTranslate();
  const { t } = i18n;
  const allowedEdit = allowed([AllRoles.INVENTORY.STOCK_ADJUSTMENT], 'write');
  const [hasDirty, setHasDirty] = useState(false);
  const [data, setData] = useState([])

  const colName = [
    {
      title: t("LoyaltyApp.image"),
      dataIndex: 'image_url',
      key: 'image_url',
      width: 150,
      className: 'enable-click',
      render: (text) => <img width="100px" src={text} />
    },
    {
      title: t("LoyaltyApp.title"),
      dataIndex: 'title',
      key: 'title',
      className: 'enable-click',
    },
    {
      title: t("LoyaltyApp.from"),
      dataIndex: 'from',
      key: 'from',
      className: 'enable-click',
    },
    {
      title: t("LoyaltyApp.start_time"),
      dataIndex: 'start_time',
      key: 'start_time',
      className: 'enable-click',
    },
    {
      title: t("LoyaltyApp.to"),
      dataIndex: 'to',
      key: 'to',
      className: 'enable-click',
    },
    {
      title: t("LoyaltyApp.end_time"),
      dataIndex: 'end_time',
      key: 'end_time',
      className: 'enable-click',
    },
    {
          title: t("General.status"),
          dataIndex: 'status',
          key: 'status',
          sorter: true,
          render: (text, record) =>
            <div className='flex align-items-center'>
              <span className={text === "active" ? "c-success" : "c-danger"}>
                {t(`General.${text?.toLowerCase()}`)}
              </span>
              {
                allowedEdit &&
                <Button type="link" onClick={() => onAction(record.id, text)}>
                  {text === "active" ? `(${t("General.deactivate")})` : `(${t("General.activate")})`}
                </Button>
              }
            </div>
        },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text, record) =>
        <ActionButton
          title="ad"
          btnAction1={() => navigate(`/loyalty-app/ads/${record.id}`)}
          recordId={record.id}
          onRemove={allowed([AllRoles.INVENTORY.STOCK_ADJUSTMENT], 'delete') && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ];

  const addNew = () => navigate('/loyalty-app/ads/add');

  const btnList = [
    {
      title: t("Product.confirm_reorder_list"),
      text: t("General.update_listing"),
      classes: 'b-success attendance-success',
      btnHidden: !hasDirty,
      action: () => onUpdateList()
    },
    {
      title: t("LoyaltyApp.confirm_remove_selected_ads"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("LoyaltyApp.add_ad")}`,
      classes: 'attendance-success',
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    reloadApi();
  }, []);

  const reloadApi = () => {
    if (!globalListQuery.productListQuery) {
      dispatch(getAds(1, limit, '', '', null, props.setLoading));
    } else {
      // console.log(listQuery)
      const { page, limit, sortOrder, sortColKey, searchValue } = globalListQuery.productListQuery
      dispatch(getAds(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }

  const onTableChange = (pagination, filters, sorter) => {
    console.log(sorter);
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if(Array.isArray(sorter)){
      dispatch(getAds(pagination.current, pagination.pageSize, "", "", searchVal, props.setLoading, sorter));
    } else if (sorter.order) {
      dispatch(getAds(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
    } else {
      dispatch(getAds(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
    }
  }

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onAction = async (recId, status) => {
    props.setLoading(true);

    const payload = {
      ad_id: recId,
      status_event: status === "active" ? "deactivate" : "activate"
    }

    await removeAd(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("General.status_update_success"));
        setTimeout(() => dispatch(getAds(page, limit, '', '', searchVal, props.setLoading)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onRemove = async (id) => {
    props.setLoading(true);

    const payload = {
      ad_id: id,
      status_event: 'remove'
    }

    await removeAd(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("LoyaltyApp.ad_remove_success"));
        setTimeout(() => dispatch(getAds(page, limit, '', '', searchVal, props.setLoading)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      ads: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveAds(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("LoyaltyApp.ads_remove_success"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getAds(1, limit, '', '', null, props.setLoading)), 500);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        title: search.title,
      };
      setSearchVal(searching);
      dispatch(getAds(1, limit, '', '', searching, props.setLoading));
    } else {
      setSearchVal(null);
      dispatch(getAds(1, limit, '', '', null, props.setLoading));
    }
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click"))
        navigate(`/loyalty-app/ads/${record.id}`);
      },
    };
  };

  useEffect(() => {
    if(ads) {
      setData(ads?.list);
    } 
  }, [ads]);

  const onUpdateList = async () => {
    props.setLoading(true);

    const payload = {
      ads: JSON.stringify(data?.map((d, i) => ({ id: d.id, position: i + 1 })))
    }
    await updateAdOrder(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("LoyaltyApp.ad_order_update_success"));
        setHasDirty(false);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("LoyaltyApp.ads")} btnList={allowed([AllRoles.INVENTORY.STOCK_ADJUSTMENT], 'write') ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="clickRow">
          <DndListCard
            setHasDirty={setHasDirty}
            setDataList={setData}
            list={data}
            classes="nopad"
            ListData={data?.map(x => ({ ...x, key: x.id }))}
            onChange={onTableChange}
            ListCol={colName}
            rowSelection={rowSelection}
            pagination={{
              total: ads?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
    </>
  )
}